// --------------------FUNCTIONS----------------------//

function modifyViewCart() {
  const cartLink = $('.cartMenuLink');
  const textContent = cartLink.text();
  const trimmedContent = textContent.replace('Items', '');
  cartLink.text(trimmedContent);
}

function modifyBtnTickets() {
  const btnTickets = document.querySelector('.header .ticket');
  btnTickets.classList.replace('ticket', 'button-tickets');
  btnTickets.textContent = 'Tickets';
  btnTickets.setAttribute('aria-label', 'Click here to buy tickets');
  btnTickets.setAttribute('aria-hidden', 'true');
}

function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <span></span>
    <span></span>
    <span></span>
  `;
  navToggle.setAttribute('tabindex', '0');
  navToggle.setAttribute('role', 'button');
  navToggle.setAttribute('aria-label', 'open menu');
}

function modifyEmailSubmitButton() {
  $('.inputFieldSubmit.emailSubmitButton').attr('role', 'button');
  $('.inputFieldSubmit.emailSubmitButton').attr('tabIndex', '0');
}

function modifyLineUpTitle() {
  if ($('.featureLineupModule').length) {
    $('.featureLineupContainer').each(function () {
      $(this)
        .find('.featureLineup-headline')
        .insertAfter($(this).find('.featureLineupImage'));
    });
  }
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  modifyEmailSubmitButton();
  modifyBtnTickets();
  modifyBtnNavToggle();
  modifyLineUpTitle();

});

$(window).load(() => {
  // ---
  modifyViewCart();
});
